import Vue from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import { appSettings } from '@/Shared/appSettings.js';

Vue.component('sform-tags', {
    mixins: [BaseComponent],
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    mounted() {
        if (this.autofocus)
            setTimeout(() => {
                const item = this.$refs[this.autofocus_id];
                if (item) {
                    this.$refs[this.autofocus_id].focus();

                    let inputEl = this.$refs[this.autofocus_id].$el.querySelector('input');
                    inputEl.select();

                    //this.input = 'test value'
                    setTimeout(() => {
                        inputEl.select();
                    }, 200);
                }
            }, 250);

        this.loadComplete();
    },
    computed: {
    },
    methods: {
    },
    render(h) {
        let scopedSlots = {
            message: ({message}) => {
                return <translation-container context={this} value={message}></translation-container>
            }
        }

        let slots = [
            <translation-container slot="label" context={this} value={this.labelText}></translation-container>,
        ];

        let input =
            <v-combobox
                ref={this.autofocus ? this.autofocus_id : undefined}
                prefix={this.element.fieldAddonLeft}
                outlined single-line dense hide-details
                multiple chips
                style={{ width: "100%" }}
                value={this.itemvalue}
                rules={this.rules}
                on-input={(value) => this.sync(value)}
                on-blur={this.onBlur}
                on-focus={this.onFocus}
                scopedSlots={scopedSlots}
                hint={this.hintText}
                persistent-hint={appSettings.DebugTranslationPrefixSetting}
            >{slots}</v-combobox>;

        if (this.appearance)
            input.componentOptions.propsData = { ...input.componentOptions.propsData, ...this.appearance };

        return input;
    }
});